import { useState, useEffect } from "react";

// Slightly modified version of the one from: https://usehooks.com/useDebounce/
const useDebounce = <T>(value : T, delay : number) => {

    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
      () => {
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay]
    );
    return debouncedValue;
  }

  export { useDebounce };